<!-- eslint-disable vue/no-v-html -->
<template>
  <div ref="news-block" class="news-block">
    <div class="news-block-columns has-side-bars">
      <div class="news-block-column-title">
        <h2 class="news-block-main-title">{{ $t('news_title') }}</h2>
        <h3 class="news-block-main-subtitle">{{ $t('news_desc') }}</h3>
      </div>
      <div class="news-block-column-content">
        <template v-if="newsCards">
          <div v-if="newsCards.code === 500" class="cms-error">{{ $t('not_cms') }}</div>
          <template v-else>
            <NewsCard
              v-for="(card, i) in cardsViewed"
              :key="i"
              :card="card"
              @toggle-selected-card="toggleSelectedCard"
            />
            <div class="news-block-pagination">
              <Paginate
                v-model="pagePagination"
                :page-count="numberOfPages"
                :page-range="1"
                :margin-pages="1"
                :click-handler="changePagePagination"
                :prev-text="`<div class='icon-search-prev'/>`"
                :next-text="`<div class='icon-search-next'/>`"
                container-class="pagination-list"
                page-class="pagination-new"
              />
            </div>
          </template>
        </template>
        <Loader v-else :text="$t('loading')" />
      </div>
    </div>
    <modal
      name="modal-news-card"
      :width="isMobile ? '90%' : '60%'"
      :height="isMobile ? '80%' : '80%'"
      :style="isMobile ? 'marginTop: 5%' : 'marginTop: 3.5%'"
    >
      <ModalNewsDetail
        :modal-close="modalClose"
        :details-info="selectedCard"
        :find-other-new="findOtherNew"
        :first-new="firstNew"
        :last-new="lastNew"
      />
    </modal>
  </div>
</template>

<script>
import ModalNewsDetail from '../modals/ModalNewsDetail.vue'
import NewsCard from './NewsCard.vue'
import Paginate from 'vuejs-paginate'
import Loader from '../Loader.vue'
import { getCMSNews } from '@/services/graphql'
export default {
  components: { ModalNewsDetail, NewsCard, Paginate, Loader },
  props: {},
  data() {
    return {
      pagePagination: 1,
      itemsForPage: 5,
      selectedCard: null,
    }
  },

  computed: {
    firstNew() {
      if (this.selectedCard) {
        let indexCurrentCard = this.newsCards.findIndex(el => el.id === this.selectedCard.id)
        return indexCurrentCard === 0 ? true : false
      } else return false
    },
    lastNew() {
      if (this.selectedCard) {
        let indexCurrentCard = this.newsCards.findIndex(el => el.id === this.selectedCard.id)
        return indexCurrentCard === this.newsCards.length - 1 ? true : false
      } else return false
    },
    numberOfPages() {
      return this.newsCards && Math.ceil(this.newsCards.length / this.itemsForPage)
    },
    cardsViewed() {
      let startView = (this.pagePagination - 1) * this.itemsForPage
      return this.newsCards && this.newsCards.slice(startView, startView + this.itemsForPage)
    },
  },
  asyncComputed: {
    newsCards() {
      return getCMSNews(this.$store.state.i18n.lang).then((resp) =>
        {
          if(resp.code === 500) return resp
          else return resp.sort((a, b) => {
            return a.score - b.score
          })
        }
      )
    },
  },
  watch: {},
  methods: {
    toggleSelectedCard(card) {
      this.selectedCard = card
    },
    changePagePagination(page) {
      let element = this.$refs['news-block']
      let header = document.getElementById('header').offsetHeight
      let top = element.offsetTop - header
      window.scrollTo(0, top)
      this.pagePagination = page
    },
    modalClose() {
      this.$modal.hide('modal-news-card')
      this.selectedCard = null
    },
    findOtherNew(key, currentNew) {
      //key = 'prev/next'
      let indexCurrentCard = this.newsCards.findIndex(el => el.id === currentNew.id)
      if (key === 'next' && indexCurrentCard === this.newsCards.length - 1) {
        this.toggleSelectedCard(this.newsCards[0])
      } else if (key === 'prev' && indexCurrentCard === 0) {
        this.toggleSelectedCard(this.newsCards[this.newsCards.length - 1])
      } else this.toggleSelectedCard(this.newsCards[indexCurrentCard + (key === 'next' ? 1 : -1)])
    },
  },
}
</script>

<style lang="stylus" scoped>
.news-block
  padding-top: vw(90px)
  padding-bottom: vw(90px)
  background-color: $light-grey

  .mobile &
    padding-top: vw(50px)
    padding-bottom: vw(50px)

.news-block-columns
  display: flex
  gap: vw(40px)

  .mobile &
    display: block

.news-block-column-title
  flex: 0 0 vw(250px)

  .mobile &
    margin-bottom: vw(20px)

.news-block-main-title
  m-font-size(35, 45)
  margin-block-start: 0
  margin-block-end: vw(10px)
  font-weight: 600
  color: $base-font-color

.news-block-main-subtitle
  m-font-size(18, 26)
  color: $grey
  margin-block-start: 0
  margin-block-end: 0

.news-block-column-content
  position: relative
  display: flex
  flex: 1 1 0%
  flex-direction: column
  gap: vw(15px)

  .mobile &
    min-height: vw(150px)
    justify-content: center

.news-block-pagination
  margin-top: vw(20px)

  .pagination-list
    .mobile &
      justify-content: center

.cms-error
  m-font-size(20, 26)
  margin-top: vw(20px)
  margin-bottom: vw(20px)
  color: #000
  text-align: center
</style>